import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import Component from '../components/HostnameCertSettingsStatusPanelContent';

const GET_SITE_IDENTIFIER = gql`
  query GetSiteActivation {
    currentSite {
      id
      identifier
    }
  }
`;

const propTypes = {};

const HostnameCertSettingsStatusPanelContent = (props) => {
  const {
    data: siteIdentifierData,
    loading: siteIdentifierLoading,
    errors: siteIdentifierErrors,
  } = useQuery(GET_SITE_IDENTIFIER);

  if (siteIdentifierLoading || siteIdentifierErrors?.length || !siteIdentifierData) {
    return null;
  }

  const { currentSite: { identifier } } = siteIdentifierData;

  return (
    <Component {...props} identifier={identifier} />
  );
};

HostnameCertSettingsStatusPanelContent.propTypes = propTypes;

export default HostnameCertSettingsStatusPanelContent;
